var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Link } from 'react-router-dom';
import React from 'react';
import styled from '../../utils/styled-components';
var getActiveState = function (active, hover) {
    return active ? 'active' : hover ? 'hover' : 'base';
};
var Wrapper = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: ", ";\n  height: ", ";\n  margin: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  text-decoration: none;\n  background: ", ";\n  border: ", ";\n  border-radius: ", ";\n  outline: 0;\n  user-select: none;\n\n  &:focus {\n    box-shadow: ", ";\n  }\n\n  &:hover {\n    background: ", ";\n    border: ", ";\n    color: ", ";\n    cursor: ", ";\n  }\n"], ["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: ", ";\n  height: ", ";\n  margin: ", ";\n  color: ",
    ";\n  font-size: ",
    ";\n  font-weight: 700;\n  text-decoration: none;\n  background: ",
    ";\n  border: ",
    ";\n  border-radius: ",
    ";\n  outline: 0;\n  user-select: none;\n\n  &:focus {\n    box-shadow: ", ";\n  }\n\n  &:hover {\n    background: ",
    ";\n    border: ",
    ";\n    color: ",
    ";\n    cursor: ", ";\n  }\n"])), function (_a) {
    var component = _a.theme.component;
    return component.pagination.width;
}, function (_a) {
    var component = _a.theme.component;
    return component.pagination.height;
}, function (_a) {
    var component = _a.theme.component;
    return component.pagination.margin;
}, function (_a) {
    var active = _a.active, component = _a.theme.component;
    return component.pagination[getActiveState(active)].color;
}, function (_a) {
    var component = _a.theme.component;
    return component.pagination.fontSize.control;
}, function (_a) {
    var active = _a.active, component = _a.theme.component;
    return component.pagination[getActiveState(active)].background;
}, function (_a) {
    var active = _a.active, component = _a.theme.component;
    return component.pagination[getActiveState(active)].border;
}, function (_a) {
    var component = _a.theme.component;
    return component.pagination.borderRadius;
}, function (_a) {
    var component = _a.theme.component;
    return component.pagination.boxShadow;
}, function (_a) {
    var active = _a.active, component = _a.theme.component;
    return component.pagination[getActiveState(active, true)].background;
}, function (_a) {
    var active = _a.active, component = _a.theme.component;
    return component.pagination[getActiveState(active, true)].border;
}, function (_a) {
    var active = _a.active, component = _a.theme.component;
    return component.pagination[getActiveState(active, true)].color;
}, function (_a) {
    var active = _a.active;
    return (active ? 'default' : 'pointer');
});
var StyledLink = styled(Link)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"])));
var Control = function (_a) {
    var _b = _a.active, active = _b === void 0 ? false : _b, onClick = _a.onClick, value = _a.value, _c = _a.to, to = _c === void 0 ? '' : _c;
    if (to && !active) {
        return (React.createElement(StyledLink, { to: to },
            React.createElement(Wrapper, { active: active, "data-testid": active ? 'pagination-control-active' : 'pagination-control', onClick: function () { return onClick(value); }, type: "button" }, value)));
    }
    return (React.createElement(Wrapper, { active: active, "data-testid": active ? 'pagination-control-active' : 'pagination-control', onClick: function () { return onClick(value); }, type: "button" }, value));
};
export default Control;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map